import { Box, Typography, Grid, Link } from "@mui/material";

const ThankYouPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "20px",
        textAlign: "center",
        maxWidth: "600px",
      }}
    >
      <Grid item xs={12} sm="auto" display="flex" justifyContent="center" style={{ marginTop: "2.5rem" }}>
        <Link href={`/`}>
          <img
            src="https://portal.hardhats.co.uk/img/Hardhats-Logo.png"
            alt="HardHats Logo"
            style={{ width: "200px", marginRight: "20px" }}
          />
        </Link>
      </Grid>
      <Typography variant="h3" component="h1" gutterBottom>
        Thank You!
      </Typography>
      <Typography variant="h5" component="p">
        Your contract has been signed successfully.
      </Typography>
      <Typography variant="h5" component="p">
        A member of our team will be in touch shortly to discuss next steps.
      </Typography>
    </Box>
  );
};

export default ThankYouPage;
